export const THEME_OPTIONS = {
  standard: 'Standard',
  premium: 'Premium',
  destructive: 'Destructive',
};
